export default __webpack_public_path__ + "static/media/R_CFUTURO.ba29ac69.pdf";